import React, { Component } from 'react';
import { connect } from 'react-redux';
import './FullScreenImage.scss';
import { showFullscreenImage } from '../actions/ShoutoutsActions';
import { Icon } from '@material-ui/core';

class FullScreenImage extends Component {
  hoverTimeout = null;
  lastHover = null;

  componentDidMount() {
    document.addEventListener("keyup", (e) => this.didExit(e));
    document.addEventListener('mousemove', () => this.onHover());

  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.didExit);
    document.removeEventListener('mousemove', this.onHover);
  }

  onHover() {
    const now = Date.now();

    if (this.lastHover === null || now - this.lastHover > 250) {
      this.lastHover = now;

      const backdrop = document.getElementById('backdrop');
      const header = document.getElementById('escape');

      if (backdrop) {
        backdrop.style.cursor = 'default';
        header.style.opacity = 1;
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);

        this.hoverTimeout = setTimeout(() => {
          backdrop.style.cursor = 'none';
          header.style.opacity = 0;
        }, 2000);
      }
    }
  }

  didExit(e) {
    if (e.key === 'Escape') this.exitFullscreen();
    if (e.key === 's') this.exitFullscreen();
  }

  exitFullscreen() {
    this.props.showFullscreenImage('');
  }

  render() {
    if (!this.props.image) return null;
    return (
      <div onClick={this.exitFullscreen.bind(this)} id="backdrop" className="fullscreen-image-background">
        <div id="escape">
          <div className="fullscreen-esc" onClick={this.exitFullscreen.bind(this)} >
            Press ESC to exit full screen
          </div>
          <div onClick={this.exitFullscreen.bind(this)} className="cancel-button">
            <Icon>close</Icon>
          </div>
        </div>
        <img
          className="shoutout-image-fullscreen"
          id="shoutout-image-fullscreen"
          onClick={(e) => e.stopPropagation()}
          src={this.props.image}
          alt=""
        />
      </div>
    );
  }
}

const mapStateToProps = ({ shoutoutsStore }) => {
  const { image } = shoutoutsStore;
  return { image };
};

export default connect(mapStateToProps, { showFullscreenImage })(FullScreenImage);


// WEBPACK FOOTER //
// ./src/components/FullScreenImage.js